/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading your calendar…" |
*
* @param {Agenda_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_loading = /** @type {((inputs?: Agenda_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je agenda wordt geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de votre agenda…")
	return /** @type {LocalizedString} */ ("Loading your calendar…")
});